import { AttachmentTypeEnum } from 'modules/community/types/post-attachment'

export const playableAttachmentTypes = [AttachmentTypeEnum.EmbeddedVideo, AttachmentTypeEnum.Video]
